<template>
  <div>
    <div class="form-group row mb-3">
      <label class="col-sm-4" :for="`mellek_alapterulet_${bKey}`"
        >Melléképület alapterülete: <span class="text-danger">*</span>
      </label>
      <ValidationProvider
        rules="required|min_value:1|max_value:9999"
        name="mellekepulet_alapterulet"
        v-slot="{errors, classes}"
        class="col-sm-8"
      >
        <div class="input-group">
          <input
            class="form-control"
            type="number"
            v-model.number="floorArea"
            :min="1"
            :max="9999"
            :id="`mellek_alapterulet_${bKey}`"
            :aria-describedby="`mellek_alapterulet_${bKey}_m2`"
            :class="{classes, 'dark-border':true}"
            required
          />
          <div class="input-group-append d-block">
            <span class="input-group-text" :id="`mellek_alapterulet_${bKey}_m2`">m2</span>
          </div>
        </div>
        <small :id="`mellek_alapterulet_${bKey}-error`" class="text-danger input-alert">{{
          errors[0]
        }}</small>
      </ValidationProvider>
    </div>
    <div class="form-group row mb-3">
      <label class="col-sm-4" :for="`mellek_falazat_${bKey}`"
        >Milyen a biztosítani kívánt melléképület falazata?
        <span class="text-danger">*</span></label
      >
      <div class="col-sm-8">
        <select class="form-select dark-border" :id="`mellek_falazat_${bKey}`" v-model="wallType" required>
          <option :value="'tegla'">Tégla</option>
          <option :value="'beton'">Beton</option>
          <option :value="'ko'">Kő</option>
          <option :value="'panel'">Panel</option>
          <option :value="'konnyuszerk'">Könnyűszerkezetes</option>
          <option :value="'fa'">Fa</option>
          <option :value="'valyog'">Vályog</option>
          <option :value="'vegyes'">Vegyes (vályog és szilárd)</option>
        </select>
        <span v-if="showPropertyWallWarning()"
          ><small class="text-warning fw-bold"
            >A megadott falazat típusra Édes Otthon Lakásbiztosítás nem köthető.</small
          ></span
        >
      </div>
    </div>
    <div class="form-group row mb-3">
      <label class="col-sm-4" :for="`mellek_tetozet_${bKey}`"
        >Milyen a biztosítani kívánt melléképület tetőzete?
        <span class="text-danger">*</span></label
      >
      <div class="col-sm-8">
        <select class="form-select dark-border" :id="`mellek_tetozet_${bKey}`" v-model="roofType" required>
          <option :value="'cserep'">Cserép</option>
          <option :value="'pala'">Pala</option>
          <option :value="'nad'">Nád</option>
          <option :value="'fazsindely'">Fazsindely</option>
          <option :value="'szalma'">Szalma</option>
          <option :value="'bitumen'">Bitumenes</option>
          <option :value="'muanyag'">Műanyag</option>
          <option :value="'fem'">Fém</option>
          <option :value="'hullamlemez'">Bitumenes hullámlemez</option>
        </select>
        <span v-if="showPropertyRoofWarning()"
          ><small class="text-warning fw-bold"
            >A megadott tetőzet típusra Édes Otthon Lakásbiztosítás nem köthető.</small
          ></span
        >
        <!-- <span v-if="showPropertyRoofWarning()"
          ><small class="text-warning fw-bold"
            >A megadott tetőzet típusra nem tudunk automatikusan biztosítási díjat számolni. Ebben
            az esetben biztosítási ajánlatát egyedi elbírálás alapján állítjuk ki.</small
          ></span
        > -->
      </div>
    </div>
    <div class="form-group row">
      <label class="col-sm-4" :for="`mellek_torles_${bKey}`">
        Melléképület törlése<br />
        <span class="text-danger fw-normal"
          >A törlés választásával a melléképület beírt adatai elvesznek.</span
        >
      </label>
      <div class="col-sm-8">
        <button type="button" class="btn btn-red w-100" @click="deleteBuilding">Törlés</button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapFields } from 'vuex-map-fields';

export default {
  props: ['bKey', 'building'],
  computed: {
    ...mapFields(['stopProcess']),
    floorArea: {
      get() {
        return this.$store.state.insuranceSideBuildings.list[this.bKey].floorArea;
      },
      set(value) {
        this.$store.commit('updateSideBuilding', {
          building: this.bKey,
          key: 'floorArea',
          value: value,
        });
      },
    },
    wallType: {
      get() {
        return this.$store.state.insuranceSideBuildings.list[this.bKey].wallType;
      },
      set(value) {
        this.$store.commit('updateSideBuilding', {
          building: this.bKey,
          key: 'wallType',
          value: value,
        });
      },
    },
    roofType: {
      get() {
        return this.$store.state.insuranceSideBuildings.list[this.bKey].roofType;
      },
      set(value) {
        this.$store.commit('updateSideBuilding', {
          building: this.bKey,
          key: 'roofType',
          value: value,
        });
      },
    },
  },
  methods: {
    deleteBuilding() {
      this.$store.commit('deleteSideBuilding', this.bKey);
    },
    showPropertyWallWarning() {
      
      return this.stopProcess?.mell_fal?.includes(this.wallType);
    },
    showPropertyRoofWarning() {
      return this.stopProcess?.mell_teto?.includes(this.roofType);
    },
  },
};
</script>
